/**
 * Preview environment settings
 *
 * This file is where you define overrides for any of the config settings that
 * should only be applied in Vercel preview deployments.
 *
 * The preview environment is defined as 'process.env.LORE_ENV=preview', which
 * is selected by setting VERCEL_LORE_ENV=preview in the Vercel project's
 * Preview environment scope.
 *
 * The API host is kept out of source: set PREVIEW_API_ROOT (e.g.
 * https://my-api.herokuapp.com, no path) in the Vercel Preview environment
 * scope. It is injected at build time in webpack.config.js.
 */

// eslint-disable-next-line no-undef
const PREVIEW_API_ROOT = process.env.PREVIEW_API_ROOT;

export default {

  /**
   * To override a config setting, specify the name of the config file you
   * want to override, followed by the settings you want to change.
   */

  auth0: {
    skipAuth0: true // Auth0 not in the loop for preview deployments
  },

  connections: {
    default: {
      apiRoot: `${PREVIEW_API_ROOT}/steward_v2`
    },
    community: {
      apiRoot: `${PREVIEW_API_ROOT}/community_v3`
    }
  },

  custom: {
    platformUrl: function() {
      return `https://app-staging.communityshare.org`;
    }
  },

  /**
   * Intercom is enabled in the base config; keep the widget out of
   * preview deployments so it doesn't interfere with e2e runs.
   */

  intercom: {
    enabled: false
  }

}
